import {useTranslation} from 'react-i18next';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {Box, Typography} from '@mui/material';

import {profileComparisonResultCalloutSx} from './profileComparisonSectionStyles';
import {profileComparisonSelection, scorePill} from '../../../../../layouts/theme/designSystem';
import type {ProfileComparisonVerdict} from '../../types/ProfileComparisonTypes';
import {getProfileComparisonVerdictState} from '../../utils/ProfileComparison/getProfileComparisonVerdictState';

export interface Props {
  verdict: ProfileComparisonVerdict;
  profileAPublicId: string;
}

const verdictStyles = {
  aLeads: {
    bgcolor: profileComparisonSelection.slotA.bgcolor,
    color: profileComparisonSelection.slotA.color,
    borderColor: profileComparisonSelection.slotA.borderColor,
  },
  bLeads: {
    bgcolor: profileComparisonSelection.slotB.bgcolor,
    color: profileComparisonSelection.slotB.color,
    borderColor: profileComparisonSelection.slotB.borderColor,
  },
  tied: {
    bgcolor: scorePill.medium.bgcolor,
    color: scorePill.medium.color,
    borderColor: scorePill.medium.strokeColor,
  },
} as const;

export const ProfileComparisonVerdictCallout = ({verdict, profileAPublicId}: Props) => {
  const {t} = useTranslation('translation', {
    keyPrefix: 'workforceDepartmentHealthPage.profileComparison.result.verdict',
  });

  const state = getProfileComparisonVerdictState(verdict, profileAPublicId);
  const styles = verdictStyles[state];

  const messageKey =
    state === 'tied' ? 'tied' : state === 'aLeads' ? 'profileALeads' : 'profileBLeads';

  return (
    <Box
      data-testid='profile-comparison-verdict-callout'
      sx={{
        ...profileComparisonResultCalloutSx,
        bgcolor: styles.bgcolor,
        color: styles.color,
        border: `1px solid ${styles.borderColor}`,
      }}
    >
      <InfoOutlinedIcon sx={{fontSize: 20, flexShrink: 0, mt: 0.125, color: 'inherit'}} />
      <Typography sx={{fontSize: 13, fontWeight: 600, lineHeight: 1.5, color: 'inherit'}}>
        {t(messageKey, {count: verdict.dimensionsLed})}
      </Typography>
    </Box>
  );
};
